import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './assets/lang/en.json'
import vi from './assets/lang/vi.json'
import VueSession from 'vue-session'
Vue.use(VueSession, {
  persist: true
})

Vue.use(VueI18n)

const messages = { en, vi }
const i18n = new VueI18n({
  locale: 'en',
  messages,
  fallbackLocale: 'en'
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang.js